export default {
    status: {
        acknowledged: "已订购",
        created: "创建",
        sent: "已订购",
        confirmed: "已订购",
        not_confirmed: "未订购",
        delivery_email: "已发货",
        delivery_rejected: "交付异常",
        delivery_rejected_not_confirmed: "交付异常",
        shipped: "已发货",
        delayed: "延迟",
        preparing: "准备",
        processing: "加工",
        processed: "已处理",
        submitted: "已订购",
        delivery_not_received: "已发货",
        shipment_exception: "已发货",
        pre_pending_approval: "待办的",
        pending_approval: "待办的",
        approved: "得到正式认可的",
        not_approved: "未批准",
        canceled: "取消",
        returned: "已返回",
        lost_shipment: "丢失的货物",
        delivery_not_confirmed: "发表",
        delivered: "发表",
        delivery_received: "发表",
        refurbished: "退货已完成",
        returned_to_office: "重返办公室",
        return_to_employer: "退还给雇主",
        return_pickup_scheduled: "已安排取货",
        return_pickup_completed: "取货完成",
        return_pickup_excluded: "不包括取货",
        return_pickup_submitted: "已提交取件",
        return_pickup_finalized: "取货已完成",
        disposed: "已处置",
        damaged: "损坏的",
        transferred: "已转移",
        transfer_received: "已收到转账"
    }
}